import { render, staticRenderFns } from "./PosBillingSettings.vue?vue&type=template&id=12fa8dc8&scoped=true"
import script from "./PosBillingSettings.vue?vue&type=script&lang=js"
export * from "./PosBillingSettings.vue?vue&type=script&lang=js"
import style0 from "./PosBillingSettings.vue?vue&type=style&index=0&id=12fa8dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fa8dc8",
  null
  
)

export default component.exports